<template>
  <div class="product-detail">
    <swiper v-if="getMbBannerList(bannerList).length" ref="refBanner"  class="banner" :options="swiperOption" @slide-change-transition-end="swiperChange">
<!--      item.type 1:pc 2:mb-->
      <swiper-slide v-for="(item, index) in getMbBannerList(bannerList)" :key="index">
        <!--        bannerType 1和null:图片 2:视频    @click="bannerPreview(index)"-->
        <van-image v-if="item.bannerType!=1" class="banner-img" :src="item.image" alt="" style="width: 100%;height: 100%"/>
        <DestinationVideo
            v-else
            :videoUrl="item.image"
            :coverUrl="item.videoImage"
            :is-white-btn="true"
            @onChangeVideo="onChangeVideoPlay"
        ></DestinationVideo>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <Destination-alert :isShow="isShowVideo" :videoUrl="videoUrl" @closeVideo="clickVideoPlayV2"></Destination-alert>
    <div class="product-info">
      <div class="info-info">
        <div class="name-line">
          <p class="name">{{productData.name}}</p>
          <a href="javascript:;" class="btn-common small btn-cart" @click="handleBooking">
            <img class="icon" src="../assets/icons/icon_cart.png" alt="">
            立即预订
          </a>
        </div>
        <div class="price-line desc-box">
          <p>{{productData.applyTo}}</p>
          <p v-show="productData.termCondition">{{productData.termCondition}}</p>
        </div>
        <div class="price-line">
          <p><span>{{priceDiscountedCalc}}</span>  {{priceUnit}} <i class="old-price" v-show="priceCalc && priceDiscountedCalc !== priceCalc">{{priceCalc}}{{priceUnit}}</i></p>
          <p v-show="productData.priceCondition">[ {{productData.priceCondition}} ]</p>
        </div>
        <div class="label-box" :class="{spec: !productData.promotionImage && productData.refImgUrl}">
          <div class="label" v-if="productData.promotionImage">
            <img class="label-img" :src="productData.promotionImage" />
          </div>
          <div class="sub-btn" v-if="productData.refImgName && productData.refImgUrl" @click="refImgPreviewShow = true">
            <img class="icon" src="../assets/icons/icon_warn.png" alt="">
            <span>{{productData.refImgName}}</span>
          </div>
        </div>
        <div v-if="productData.productGiftId>0" class="product-gift-box not-margin">
          <div class="icon">
            <img src="../assets/icons/iconGift.png" alt="" />
          </div>
          <div class="name">{{productData.productGiftName}}</div>
        </div>
      </div>
      <div class="desc-detail" v-html="productData.mobileContent"></div>
      <!-- 注意事项、条款细则 -->
      <product-rules :productData="productData" />
    </div>
    <div class="product-recommend" v-show="recommendList.length">
      <div class="recommend-title">猜您喜欢</div>
      <product-list :list="recommendList" />
    </div>
    <!-- 预定弹框 -->
    <dialog-booking :visible.sync="bookingShow" :goodsInfo="goodsInfo" />
    <!-- banner预览 -->
    <van-image-preview
      v-model="bannerPreviewShow"
      :start-position="bannerPreviewStart"
      :images="bannerImgs"
      :close-icon="require('../assets/icons/icon_close2.png')"
      closeable
      close-on-popstate
      :show-index="false"
      show-indicators
      class-name="custom-image-preview"
    />
    <!-- 参考菜单预览 -->
    <van-image-preview
      v-model="refImgPreviewShow"
      :images="[productData.refImgUrl]"
      :close-icon="require('../assets/icons/icon_close2.png')"
      closeable
      close-on-popstate
      :show-index="false"
      class-name="custom-image-preview"
    />
  </div>
</template>

<script>
import ProductRules from './booking/ProductRules'
import ProductList from './booking/ProductList'
import DialogBooking from './DialogBooking'
import api from '@/api'
import { showLoading, hideLoading, showAlert } from '@/utils/tools'
import pick from 'lodash/pick'
import { checkOrderState } from '@/plugins/common'
import { mapState } from 'vuex'
import DestinationAlert from "@/components/DestinationAlert.vue";
import DestinationVideo from "@/components/DestinationVideo.vue";

export default {
  name: 'PageProductDetail',

  components: {
    DestinationVideo,
    DestinationAlert,
    ProductRules,
    ProductList,
    DialogBooking
  },

  props: {
    id: String
  },

  data () {
    return {
      swiperOption: {
        autoplay: true,
        pagination: {
          el: '.swiper-pagination'
        }
      },
      productData: {},
      recommendList: [],
      bannerList: [],
      bookingShow: false,
      bannerPreviewShow: false,
      bannerPreviewStart: 0,
      refImgPreviewShow: false,
      isShowPlayBtn:true,
      isShowVideo:false,
      videoUrl:''
    }
  },

  watch: {
    id () {
      this.getData()
    }
  },

  computed: {
    ...mapState(['bindTicket']),
    goodsInfo () {
      let productData = {
        ...this.productData,
        productGift: null
      };
      if(productData.productGiftId) {
        productData.productGift = {
          productGiftId: productData.productGiftId,
          productGiftName: productData.productGiftName,
          productGiftDescription: productData.productGiftDescription,
          productGiftEnglishName: productData.productGiftEnglishName
        }
      }
      return Object.keys(this.productData).length ? pick(productData, ['id', 'mobileBanner', 'name', 'applyTo', 'needSync', 'subcategroy', 'categoryName', 'productGift']) : {}
    },
    priceUnit () {
      return this.bindTicket && (this.productData.priceByRouteDays || this.productData.priceByRouteNights) ? '美元/航次' : this.productData.priceUnit
    },
    priceDiscountedCalc () {
      const calcResult = this.productData.priceDiscounted - this.productData.priceDiscountedServiceCharge
      return calcResult % 1 === 0 ? calcResult : calcResult.toFixed(2)
    },
    priceCalc () {
      const calcResult = this.productData.price - this.productData.priceServiceCharge
      return calcResult % 1 === 0 ? calcResult : calcResult.toFixed(2)
    },
    bannerImgs () {
      return this.bannerList.map(x => x.image)
    }
  },

  mounted () {
    this.getData()
  },

  methods: {
    handleBooking () {
      checkOrderState(checkResult => {
        if (checkResult) {
          if (checkResult !== 'cancel') showAlert(checkResult)
        } else {
          this.bookingShow = true
        }
      })
    },
    async getData () {
      showLoading()
      const { errCode, errMsg, data } = await api.getProductDetail(this.id)
      hideLoading()
      if (errCode === 0) {
        const { recommdationViewModel, productBanner, ...productData } = data
        this.productData = productData
        this.recommendList = recommdationViewModel && recommdationViewModel.products && recommdationViewModel.products.length ? recommdationViewModel.products : []
        productBanner.forEach(item => {
          if(item.type===2){
            this.bannerList.push(item)
          }
        })
        // this.bannerList = productBanner || []
        window.gio('page.set', 'Product_DetailProduct', productData.name)
      } else {
        showAlert(errMsg || '页面数据获取失败，请稍后重试')
      }
    },
    bannerPreview (index) {
      this.bannerPreviewStart = index
      this.bannerPreviewShow = true
    },
    // 视频在播放时，停止自动轮播
    videoPlay(){
      if(this.$refs.refBanner && this.$refs.refBanner.swiper){
        this.$refs.refBanner.swiper.autoplay.stop()
      }
    },
    // 视频结束或暂停时，重新开启自动轮播
    videoEnd(){
      if(this.$refs.refBanner && this.$refs.refBanner.swiper){
        this.$refs.refBanner.swiper.autoplay.run()
        this.isShowPlayBtn = true
      }
    },
    // 切换轮播时，重新开启自动轮播并暂停视频
    swiperChange(){
      //   获取所有class为video-content下的视频
      const videoList = document.querySelectorAll('.video-content video')
      videoList.forEach(item=>{
        item.pause()
      })
      let video = document.getElementById('myVideo')
      if(video){
        video.pause()
        if(video.paused){
          this.$refs.refBanner.swiper.autoplay.stop()
        }else{
          this.$refs.refBanner.swiper.autoplay.run()
        }
      }
    },
    onChangeVideoPlay(){
      let swiper = this.$refs.refBanner.swiper
      swiper.autoplay.stop()
    },
    clickVideoPlay(url){
      this.videoUrl = url
      this.isShowVideo = true
    },
    clickVideoPlayV2(e){
      if(this.isShowVideo){
        this.isShowVideo = e
      }else{
        this.isShowVideo = true
      }
    },
    getMbBannerList(list){
      let bannerList = []
      list.forEach(item=>{
        if(item.type===2){
          bannerList.push(item)
        }
      })
      return bannerList
    }
  }
}
</script>

<style lang="less" scoped>
.banner {
  position: relative;
  .swiper-pagination ::v-deep .swiper-pagination-bullet {
    width: 16px;
    height: 5px;
    margin: 0 3px;
    border-radius: 2px;
    background-color: #dedede;
    &.swiper-pagination-bullet-active {
      width: 46px;
      .btn-linear-gradient;
    }
  }
  & video{
    width: 100%;
    height: 100%;
  }
  & img{
    width: 100%;
    height: 100%;
  }
  & .videoBtn{
    position: absolute;
    width: 100px;
    height: 100px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    & img{
      width: 100%;
    }
  }
}
.product-info {
  padding: 0 50px;
  background-color: #fff;
  .info-info {
    padding: 24px 0 18px;
    border-bottom: 1Px solid #eaeaea;
    .name-line {
      display: flex;
      justify-content: space-between;
      .name {
        flex: none;
        width: 436px;
        font-size: 30px;
        color: #333;
        line-height: 40px;
        font-weight: bold;
      }
      .btn-cart {
        width: 162px;
        height: 52px;
        margin: 0;
        font-size: 24px;
        .icon {
          width: 25px;
          margin-right: 10px;
        }
      }
    }
    .price-line {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-top: 16px;
      font-size: 20px;
      color: #999;
      &.desc-box {
        align-items: flex-start;
        p {
          flex: none;
          &:first-child {
            max-width: 50%;
          }
          &:last-child {
            max-width: 45%;
          }
        }
      }
      span {
        margin-right: 3px;
        font-size: 32px;
        font-weight: bold;
        color: @second-color;
      }
      .old-price {
        font-style: normal;
        text-decoration: line-through;
      }
    }
    .label-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 18px;
      &.spec {
        padding-top: 16px;
        justify-content: flex-end;
      }
      .label {
        .label-img {
          display: block;
          height: 30px;
          margin-right: 6px;
        }
      }
      .sub-btn {
        display: flex;
        align-items: center;
        font-size: 20px;
        color: #1174b8;
        .icon {
          width: 21px;
          height: 21px;
          margin-right: 8px;
        }
        span {
          text-decoration: underline;
        }
      }
    }
  }
  .desc-detail {
    padding: 32px 0;
    font-size: 24px;
    color: #333;
    line-height: 38px;
  }
}
.product-recommend {
  padding: 40px 50px 50px;
  .recommend-title {
    position: relative;
    height: 68px;
    margin-bottom: 30px;
    font-size: 30px;
    color: #333;
    text-align: center;
    line-height: 68px;
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      z-index: 1;
      width: 220px;
      height: 4px;
      margin-top: -2px;
      background-color: @second-color;
    }
    &::before {
      left: 0;
    }
    &::after {
      right: 0;
    }
  }
}
</style>
